<template>
  <div class="personal-load-list">
    <div class="personal-load-list__content">
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index">
          <a target="_blank" :href="item.link">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <div
      v-if="isLoad"
      class="personal-load-list__loader">
      <Loader/>
    </div>
  </div>
</template>

<script>
import Loader from '../Loader'
import priceList from '../../api/priceList'

export default {
  name: 'PriceList',
  components: {
    Loader
  },
  data: function () {
    return {
      isLoad: false,
      list: []
    }
  },
  async mounted () {
    this.isLoad = true
    this.list = await priceList()
    this.isLoad = false
  },
  beforeDestroy () {
    this.isLoad = false
    this.list = []
  }
}
</script>

<style
  lang="scss"
  scoped>
  .personal-load-list {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/PriceList.vue